/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_BeginningInputs */



/**
* | output |
* | --- |
* | "Starting…" |
*
* @param {Practice_Session_BeginningInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_beginning = /** @type {((inputs?: Practice_Session_BeginningInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_BeginningInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bezig met starten…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage…")
	return /** @type {LocalizedString} */ ("Starting…")
});